export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "BRIEF_CREATION_STEPS": {
          "STEP-1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Define core information"])},
          "STEP-2": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Configure its ", _interpolate(_named("leads"))])}
        },
        "NAME": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title"])},
          "PLACEHOLDER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter title"])},
          "VALIDATION": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize([_interpolate(_named("Brief")), " title is required"]), _normalize([_interpolate(_named("Brief")), " title is too long. ", _interpolate(_named("x")), " characters are allowed"]), _normalize([_interpolate(_named("Brief")), " title is too long. ", _interpolate(_named("x")), " characters are allowed"])])}
        },
        "NONE_OPTION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["None"])},
        "STEP_COUNT": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("step")), "/2"])},
        "STYLE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Color"])},
          "HINT": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Use this color to easily identify this ", _interpolate(_named("brief")), " and related ", _interpolate(_named("leads"))])}
        },
        "SUCCES": {
          "CREATE": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("Brief")), " successfully created"])},
          "UPDATE": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("Brief")), " successfully updated"])}
        },
        "TEMPLATE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default summary template"])}
        },
        "DEAL_TYPE": {
          "LABEL": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize(["Default ", _linked("LEAD.LOW.SING", undefined, _type), " type"])}
        },
        "TYPE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])}
        }
      }
    }
  })
}
